function initPcardCarousels() {
  document.querySelectorAll('[data-carousel]').forEach(wrapper => {
    if (wrapper._carouselInit) return;
    wrapper._carouselInit = true;

    const slides = wrapper.querySelectorAll('.m-carousel__slide');
    const dots = wrapper.querySelectorAll('.m-carousel__dot');
    const prev = wrapper.querySelector('.m-carousel__btn--prev');
    const next = wrapper.querySelector('.m-carousel__btn--next');
    if (slides.length <= 1) return;

    let current = 0;

    function goTo(i) {
      slides[current].classList.remove('is-active');
      dots[current].classList.remove('is-active');
      current = (i + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      dots[current].classList.add('is-active');
    }

    prev?.addEventListener('click', e => { e.preventDefault(); goTo(current - 1); });
    next?.addEventListener('click', e => { e.preventDefault(); goTo(current + 1); });
    dots.forEach((dot, i) => dot.addEventListener('click', e => { e.preventDefault(); goTo(i); }));

    let startX = 0;
    wrapper.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
    wrapper.addEventListener('touchend', e => {
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) goTo(diff > 0 ? current + 1 : current - 1);
    });
  });
}

// Inicializar al cargar
document.addEventListener('DOMContentLoaded', initPcardCarousels);

// Reinicializar cuando Minimog carga más productos (infinite scroll / load more)
const observer = new MutationObserver(() => initPcardCarousels());
observer.observe(document.body, { childList: true, subtree: true });

// Eventos de secciones de Shopify
document.addEventListener('shopify:section:load', initPcardCarousels);